import { ActionsFactory } from '../actions/factory'
import { Diagram } from '../diagram'
import DolfinFlowExecutor from '../flow-executor/base'
import { NodeError, NodeWarning } from '../types'
import { DolfinNode } from './base'
import { TypedNode } from './types'

/**
 * Action node (Custom Check) - executes custom actions and data validation checks.
 *
 * @see /docs/domain/nodes/custom-check.md for canonical documentation
 */
export class CustomCheckNode extends DolfinNode<DolfinFlowExecutor, 'custom-check'> {
  async process() {
    const action = ActionsFactory.create(
      this.node,
      this.flowExecutor.recordData!,
      this.flowExecutor.organizationId,
      this.flowExecutor.rpcClient
    )

    console.log('Triggering action', action)

    if (!action) {
      return false
    }

    return await action.run()
  }

  static validate(
    node: TypedNode<'custom-check'>,
    diagram: Diagram
  ): { node: TypedNode<'custom-check'>; errors: NodeError[]; warnings: NodeWarning[] } {
    const superValidation = super.validate(node, diagram)
    const actionValidation = ActionsFactory.validate(node, diagram)

    return {
      node,
      errors: [...superValidation.errors, ...actionValidation.errors],
      warnings: [...superValidation.warnings, ...actionValidation.warnings]
    }
  }
}
